"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsHelpers = void 0;
class StatsHelpers {
    static async monitorSectionTime(sectionId) {
        if (this.statsInterval) {
            clearInterval(this.statsInterval);
        }
        this.statsInterval = setInterval(() => {
            this.wsService.sendMessage('tutorial', 'record_time', { sectionId, participantUUID: this.participantUuid });
        }, 1000);
    }
}
exports.StatsHelpers = StatsHelpers;
